// the hex codes should be lowercase
const spotColors: StringMap<string> = {
  "#c4271d": "sm_red",
  "#004f86": "sm_blue",
  "#4f575b": "sm_grey",
  "#bc4077": "sm_pink",
  "#fee900": "sm_yellow",
  "#523d2a": "sm_brown",
  "#e15616": "sm_orange",
  "#009251": "sm_green",
  "#554585": "sm_purple",
  "#000000": "sm_black",
  "#daa520": "sm_metallic_gold",
  "#bbbbbb": "sm_metallic_silver",
  "#eed895": "sm_birch",
  "#be9261": "sm_cherry",
  "#a67e6d": "sm_cherry",
  "#f6e6b5": "sm_maple",
  "#a88f71": "sm_birch",
  "#8e7a64": "sm_oak",
  "#e8cca1": "sm_oak",
}

export const isSpotColor = (color: string) => {
  return Object.keys(spotColors).includes(color.toLowerCase())
}

export const spotColorName = (color: string) => {
  return spotColors[color]
}
